import {Async, Loaded, Loading} from 'Core/models/Async';

export class UnassignedLife70ErrorMessages {
  public readonly key = 'UnassignedLife70ErrorMessages';
}

export type Life70ErrorMessages = Async<object[]> | UnassignedLife70ErrorMessages;

type MatchLife70ErrorMessagesOptions<TReturn> = {
  Loading: () => TReturn;
  Loaded: (life70ErrorMessages: object[]) => TReturn;
  Error: () => TReturn;
  Unassigned: (life70ErrorMessages: []) => TReturn;
};

export const isLoading = (life70ErrorMessages: Life70ErrorMessages): life70ErrorMessages is Loading<object[]> =>
  life70ErrorMessages.key === 'Loading';

export const isLoaded = (life70ErrorMessages: Life70ErrorMessages): life70ErrorMessages is Loaded<object[]> =>
  life70ErrorMessages.key === 'Loaded';

export const matchLife70ErrorMessages = <TReturn>(options: MatchLife70ErrorMessagesOptions<TReturn>) => (
  life70ErrorMessages: Life70ErrorMessages
) => {
  switch (life70ErrorMessages.key) {
    case 'UnassignedLife70ErrorMessages':
      return options.Unassigned([]);
    case 'Loaded':
      return options.Loaded(life70ErrorMessages.Data);
    case 'Loading':
      return options.Loading();
    case 'Conflict':
      return options.Error();
    case 'ServerError':
      return options.Error();
    case 'Unauthorized':
      return options.Error();
  }
};
